"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startsWith = exports.endsWith = void 0;
function endsWith(str, search) {
    const strLength = str.length;
    return str.substring(strLength - search.length, strLength) === search;
}
exports.endsWith = endsWith;
function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
exports.startsWith = startsWith;
//# sourceMappingURL=utils.js.map